import React, { useRef, useEffect, useState } from 'react'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import './model-bob.scss'


import curV from '../../../assets/images/model/cur-v.png'

import useMediaQuery from '../../../utils/useMediaQuery'
import InfoCurV from '../info-cur-v/info-cur-v'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { Link } from 'gatsby'
import botonFlechaHome from '../../../assets/images/botonFlechaHome.png'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModelBob = () => {
  const isMobile = useMediaQuery()

  const mountRef = useRef(null)

  const [zone, setZone] = useState(-1)


  const refScroll = useRef(null)
  const executeScroll = () => refScroll.current.scrollIntoView()


  useEffect(() => {
    //Data from the canvas
    const currentRef = mountRef.current
    const { clientWidth: width, clientHeight: height } = currentRef

    //Scene, camera, renderer
    const scene = new THREE.Scene()
    const camera = new THREE.PerspectiveCamera(60, width / height, 1, 1000)


    scene.add(camera)
    camera.position.set(-5, 2.5, isMobile ? -6.2 : -5)
    camera.lookAt(new THREE.Vector3())


    const renderer = new THREE.WebGLRenderer({ alpha: true })
    renderer.setSize(width, height)
    currentRef.appendChild(renderer.domElement)

    //OrbitControls
    const orbitControls = new OrbitControls(camera, renderer.domElement)
    orbitControls.enableDamping = true
    orbitControls.enableZoom = false
    orbitControls.touches = {
      ONE: THREE.TOUCH.ROTATE,
      TWO: false,
    }


    //Resize canvas
    const resize = () => {
      renderer.setSize(currentRef.clientWidth, currentRef.clientHeight)
      camera.aspect = currentRef.clientWidth / currentRef.clientHeight
      camera.updateProjectionMatrix()


    }
    window.addEventListener('resize', resize)

    // mouse coors

    const mouseCoors = new THREE.Vector2()

    function onPointerMove(event) {
      mouseCoors.x = (event.clientX / window.innerWidth) * 2 - 1
      mouseCoors.y = -(event.clientY / window.innerHeight) * 2 + 1

    }

    window.addEventListener('mousemove', onPointerMove)


    // mouseCLick
    let currentMesh = null
    let isVisible = false

    const mouseClick = () => {

      if ((currentMesh && currentMesh.object.name !== 'TOALLA_SE_V12') && isVisible) {
        switch (currentMesh.object.name) {
          case 'PUNTO_1':
            setZone(0)
            pushEventDataLayer('Interacciones - 360','Cur-v','Click','3 Zonas de absorción inteligente',)
            break
          case 'ZONAS':
            setZone(1)
            pushEventDataLayer('Interacciones - 360','Cur-v','Click','Canales que distribuyen el flujo')
            break
          case 'PUNTO_3':
            setZone(2)
            pushEventDataLayer('Interacciones - 360','Cur-v','Click','Alas asimétricas')
            break
          case 'PUNTO_4':
            setZone(3)
            pushEventDataLayer('Interacciones - 360','Cur-v','Click','Se adapta a tu Zona V')
            break
          default:
            setZone(-1)
            break
        }
      }
    }

    window.addEventListener('click', () => mouseClick())


    // loader
    const setTexturehdr = async () => {
      const rgbeLoader = new RGBELoader().setPath('textures/equirectangular/')
      const texture = await rgbeLoader.loadAsync('venice_sunset_1k.hdr')
      texture.mapping = THREE.EquirectangularReflectionMapping
      scene.environment = texture
    }


    const bob = new THREE.Group()
    let originalCollitions
    const gltfLoader = new GLTFLoader()
    gltfLoader.load('./model.gltf',
      (gltf) => {
        bob.add(gltf.scene)
        scene.add(bob)
        bob.position.y = isMobile ? 0 : -1
        // bob.translateY(isMobile ? -2 : -1)
      })

    setTexturehdr()


    // Rycaster
    const rycaster = new THREE.Raycaster()
    const collitions = bob.children

    let observer
    let target
    //Animate the scene
    const animate = () => {
      // options intersection
      const thresholdOption = 0.60

      const options = {
        threshold: thresholdOption,
      }

      const handlerIntersection = (entries) => {
        const entry = entries[0]
        isVisible = entry.intersectionRatio >= thresholdOption
      }

      observer = new IntersectionObserver(handlerIntersection, options)

      target = document.querySelector('.f-container-model')
      observer.observe(target)


      // rycaster setuo

      rycaster.setFromCamera(mouseCoors, camera)

      const rycasterCollitions = rycaster.intersectObjects(collitions)


      for (let original of bob?.children[0]?.children[0]?.children || []) {
        if (original.name !== 'TOALLA_SE_V12') {
          document.body.style.cursor = 'default'
        }
      }

      for (let collition of rycasterCollitions) {
        if (collition.object.name !== 'TOALLA_SE_V12' && isVisible) {
          document.body.style.cursor = 'pointer'
        }
      }

      if (rycasterCollitions.length) {
        currentMesh = rycasterCollitions[0]
      } else {
        currentMesh = null
      }


      orbitControls.update()
      renderer.render(scene, camera)
      requestAnimationFrame(animate)
    }
    animate()

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.4)
    scene.add(ambientLight)


    const directionalLightTop = new THREE.DirectionalLight(0x666666, 0.2)
    const directionalLightBottom = new THREE.DirectionalLight(0xf1f1f1, 0.2)
    directionalLightBottom.position.set(0, -1, 0)
    scene.add(directionalLightTop)
    scene.add(directionalLightBottom)

    const light = new THREE.PointLight(0x666666, 0.2, 50)
    light.position.set(0, 0, 0)
    scene.add(light)


    return () => {
      window.removeEventListener('resize', resize)
      window.removeEventListener('mousemove', onPointerMove)
      window.removeEventListener('click', mouseClick)
      currentRef.removeChild(renderer.domElement)
      observer.unobserve(target)

    }
  }, [isMobile])


  return (

    <div className='f-container-model' ref={refScroll} onClick={executeScroll}>
      <div id='visual-360' className='f-container-model__ancla' />
      <InfoCurV zone={zone} setZone={setZone} />
      <div
        className='f-container-model__model-cur-v'
        ref={mountRef}
        style={{ width: '100%', height: '100vh' }}
      ></div>

      <img className='f-container-model__cur-v-img' src={curV} alt='cur-c' />

      <Link to='#zona-virtual' className='f-container-model__scroll-down'>
        <img
          src={botonFlechaHome}
          alt='boton flecha bajar'
          className='f-bannerSection-container__info__content__botonFlecha model'
        />
      </Link>

    </div>
  )
}

export default ModelBob
